import { gql } from '@apollo/client'

export const GET_USER_INVITE = gql`
  query getUserInvite {
    getUserInvite {
      token
      used
    }
  }
`
